import { render, staticRenderFns } from "./ncrInspection.vue?vue&type=template&id=aa32aed6"
import script from "./ncrInspection.vue?vue&type=script&lang=js"
export * from "./ncrInspection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa32aed6')) {
      api.createRecord('aa32aed6', component.options)
    } else {
      api.reload('aa32aed6', component.options)
    }
    module.hot.accept("./ncrInspection.vue?vue&type=template&id=aa32aed6", function () {
      api.rerender('aa32aed6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Production/ncrInspection.vue"
export default component.exports